import React from "react";
import { IsMainMenuHasChildrens, IsExcludedforBussinesstypes } from "../../utils/Common";

import MyRoutes from "../../utils/MyRoutes";
import PrivateLink from "./PrivateLink";
import { Link } from "react-router-dom";



export default function Mainmenu(props) {
  const group = props.group;
  const hasChildrens = IsMainMenuHasChildrens(group);


  const RecursiveComponent = ({ data, group }) => {
    return data.map((parent, index) => {
      if (parent?.children?.length > 0) {
        return <RecursiveComponent data={parent.children} group={group} />;
      } else if (parent.title && parent.group === group) {

        if (!IsExcludedforBussinesstypes(parent.excluded_business_types)) {
          return (
            <PrivateLink to={`${parent.path}`} className="text-white text-decoration-none" >
              <span>{parent.title}</span>
            </PrivateLink >
          );
        }
      }
    });
  };


  if (hasChildrens) {
    return (
      <li className="nav-item dropdown hover-dropdown">
        <Link {...props} />
        <ul className="dropdown-menu newdrop" aria-labelledby="navbarDropdown">
          {<RecursiveComponent data={MyRoutes} group={group} />}
        </ul>
      </li>
    );
  } else return;


}